__turbopack_context__.v({
  "container": "ProductMetaInfo-module-scss-module__IhB2PW__container",
  "productDescription": "ProductMetaInfo-module-scss-module__IhB2PW__productDescription",
  "productName": "ProductMetaInfo-module-scss-module__IhB2PW__productName",
});
